import React, {useContext, useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import moment from "moment/moment";
import "../../App.css";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import SystemContext from "../../SystemContext";
import {isBlank} from "../../utils";
import SearchBar from "../../controls/SearchBar";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import BookingQueueList from "./components/BookingQueueList";
import BookingQueueForm from "./components/BookingQueueForm";
import BookingQueueStyles from "./styles/BookingQueueStyles";

const AccessControl = require ("../../AccessControl");

function SpecialLoadRequests(props) {
  const classes = makeStyles(BookingQueueStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Manage SLR"]);

  const SystemData = useContext(SystemContext);

  const defaultSearch = {
    fromDate: moment().startOf('day').subtract(60, 'days').toISOString(),
    toDate: moment().endOf('day').add(14, 'days').toISOString(),
    refresh: 0
  };

  const [searchCriteria, setSearchCriteria] = useState({...defaultSearch});

  const handleSearch = (search, searchRecordChange) => {
    setSearchCriteria(search);
  }

  let theme = useTheme();
  const values = {
    xs: 0,
    sm: 600,
    lsm: 720,
    md: 960,
    mlg: 1120,
    lg: 1280,
    lgr: 1750,
    xl: 1920,
    xxl: 2400
  };

  theme.breakpoints = {...theme.breakpoints,
    keys: ['xs', 'sm', 'lsm', 'md', 'mlg', 'lg', 'lgr', 'xl', 'xxl'],
    up: key => `@media (min-width:${values[key]}px)`,
  };

  const heightConstant = 99 + 2 + 10 + 57 + 4 + 75;
  const listWidthConstant = 495;
  const panelWidthConstant = listWidthConstant - 95;

  return (isAuthenticated &&
    <div
      className="BookingQueue"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="specialloadrequests"
        pageName="Special Load Requests"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{height: 10}}></div>
      <SearchBar
        shrinkAll={false}
        heading=""
        alignFields="left"
        // searchButtonStyle={{padding: "20px 5px"}}
        // clearButtonStyle={{padding: "20px 5px"}}
        fields={[
          {field: "fromDate", type: "date", label: "From Date", defaultValue: defaultSearch.fromDate},
          {field: "toDate", type: "date", label: "To Date", defaultValue: defaultSearch.toDate},
        ]}
        searchDisabled={(search) => {
          if (isBlank(search['fromDate']) && isBlank(search['toDate'])) return true;
          return false;
        }}
        eventPrefix="BookingQueue"
        onSearch={handleSearch}
        onResetSearch={handleSearch}
      />
      <div style={{height: 10}}></div>
      <div
        className={classes.rooted}
        style={{
          marginLeft: 20,
          marginRight: 20,
          minHeight: `calc(100vh - ${(heightConstant)}px)`,
          height: `calc(100vh - ${(heightConstant)}px)`
        }}
      >
        <div style={{display: "flex", width: "100%", position: "relative"}}>
          <div style={{
            display: "inline-flex",
            position: "relative",
            width: `calc(100vw - ${listWidthConstant}px)`,
            maxWidth: `calc(100vw - ${listWidthConstant}px)`
          }}>{/* minWidth: listWidth, */}
            <BookingQueueList
              tripUuid="CHANGES"
              specialLoadRequests={true}
              fromDate={searchCriteria.fromDate}
              toDate={searchCriteria.toDate}
              canEdit={canEdit} classes={classes}
              theme={theme}
              height={heightConstant}
            />
          </div>
          <div style={{
            display: "inline-flex",
            width: panelWidthConstant,
            MinWidth: panelWidthConstant,
            maxWidth: panelWidthConstant,
            height: "100%",
            marginLeft: 20,
            backgroundColor: "#ffffff"
          }}>
            <BookingQueueForm canEdit={false} classes={classes} height={heightConstant}/>
          </div>
        </div>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default SpecialLoadRequests;
